<p-dialog [modal]="true" [closable]="false" [showHeader]="false" [styleClass]="'detail-modal'" [(visible)]="visible"
  (onHide)="onHide()" [ngStyle]="editMode ? {'border-radius': '0'} : {'border-radius': '5px'}">
  <div id="paymentDetailDialogHeader" class="detail-modal-header">
    <div class="detail-modal-header__banner">
      <app-pending-invoice-banner [settlementReviewStatus]="paymentDetail.settledPaymentInvoiceStatus"></app-pending-invoice-banner>
    </div>
    <button id="closeDialogButton" type="button" class="detail-modal-close" (click)="visible=false"
      aria-label="Close dialog">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="grid">
    <!-- TOP INFO -->
    <div class="section-title mt-0">{{ 'payment_detail_title_label' | translate }}</div>
    <div class="col-12 credit-card">
      <!-- CREDIT CARD -->
      @if (paymentDetail.card) {
      <div class="screen-card">
        <div class="logo float-right">
          @if (paymentDetail.card.cardScheme === 1) {
          <img class="logo Visa" src="../../assets/images/webpay/logo-visa.png">
          }
          @if (paymentDetail.card.cardScheme === 2) {
          <img class="logo Mastercard" src="../../assets/images/webpay/logo-master-card.svg">
          }
          @if (paymentDetail.card.cardScheme === 3) {
          <img class="logo Amex" src="../../assets/images/webpay/logo-amex.svg">
          }
        </div>
        <div class="card-title" translate>CREDIT CARD</div>
        <div class="card-details">
          <div id="cardHolderField" class="card-holder sensitive-data">{{ paymentDetail.card.cardHolder }}</div>
          <div id="panField" class="card-number sensitive-data">{{ paymentDetail.card.pan }}</div>
        </div>
      </div>
      }

      <!-- BANK TRANSFER -->
      @if (!paymentDetail.card) {
      <div class="bank-transfer-logo">
        <img style="width:100%" src="../../../../../assets/images/logo/logo-bank-transfer.png">
      </div>
      }

      <!-- CRYPTA INFO -->
      <div class="col-6 col-offset-1">
        <app-payment-detail-crypta-info [paymentDetail]="paymentDetail"
          [editMode]="editMode"></app-payment-detail-crypta-info>
      </div>
    </div>

    <!-- REFERENCES -->
    @if (paymentDetail.bookings || paymentDetail.invoices) {
    <div class="col-12">
      <app-payment-detail-references [bookings]="paymentDetail.bookings" [invoices]="paymentDetail.invoices"
        [editMode]="editMode"></app-payment-detail-references>
    </div>
    }

    @if (paymentDetail.processingRules && (paymentDetail.bookings || paymentDetail.invoices)) {
    <div class="col-12">
      <hr>
    </div>
    }

    <!-- PROCESSING RULES -->
    @if (paymentDetail.processingRules) {
    <div class="col-12">
      <app-payment-detail-processing-rules
        [(processingRules)]="paymentDetail.processingRules"></app-payment-detail-processing-rules>
    </div>
    }

    <!-- BILL TO -->
    @if (paymentDetail.billTo) {
    <div class="col-12">
      <app-payment-detail-bill-to [(billTo)]="paymentDetail.billTo"></app-payment-detail-bill-to>
    </div>
    }

    <!-- COMMENT -->
    @if (paymentDetail.comments || editMode) {
    <div class="col-12" id="comments">
      <app-payment-detail-comment [(comment)]="paymentDetail.comments!"
        [editMode]="editMode"></app-payment-detail-comment>
    </div>
    }
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <div class="relative">
      <div class="absolute top-0 right-0 flex align-items-center justify-content-center">
        <!-- CANCEL -->
        <button id="cancelBtn" class="btn bg-button-white" (click)="onHide()" translate>
          {{ editMode ? 'payment_detail_cancel' : 'payment_detail_close' }}
        </button>
        <!-- SAVE -->
        @if (editMode) {
        <button id="saveBtn" class="btn bg-blue-link ml-6" (click)="save()"
          translate>payment_detail_save_changes</button>
        }
      </div>
    </div>
  </ng-template>
</p-dialog>

@if (showSpinner) {
<p-blockUI [blocked]="showSpinner">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" animationDuration=".5s">
  </p-progressSpinner>
</p-blockUI>
}